import React from 'react';
import { useLocation } from 'react-router';

import styled from '@emotion/styled';

import RightChevronIcon from '../Icons/RightChevronIcon';
import { InternalNavLink } from '../Link/Link';

interface IPath {
  name: string;
  link: string;
}

interface IBreadCrumbs {
  pathData: IPath[];
  hideOnWeb?: boolean;
}

const BreadCrumbs: React.FC<IBreadCrumbs> = ({ pathData, hideOnWeb }) => {
  const { pathname } = useLocation();

  const normalizePath = (path: string) => path.replace(/\/+$/, '') || '/';

  return (
    <Container className={hideOnWeb ? 'hide-on-web' : ''}>
      {pathData.map((item, index) => {
        const isActive =
          normalizePath(`${item.link}`) === normalizePath(pathname);

        return (
          <React.Fragment key={index}>
            {index / 2 !== 0 && <RightChevronIcon />}
            <>
              {isActive ? (
                <LinkShell className={isActive ? 'active' : ''}>
                  {item.name}
                </LinkShell>
              ) : (
                <InternalNavLink to={item.link}>
                  <LinkShell className={isActive ? 'active' : ''}>
                    {item.name}
                  </LinkShell>
                </InternalNavLink>
              )}
            </>
          </React.Fragment>
        );
      })}
    </Container>
  );
};

export default BreadCrumbs;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: #71748c;
  margin-bottom: 14px;

  @media (max-width: 884px) {
    width: 100%;
    flex-wrap: wrap;
  }

  &.hide-on-web {
    @media (min-width: 885px) {
      display: none;
    }
  }
`;

const LinkShell = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 14px;
  color: #71748c;
  font-weight: 400;

  &.active {
    color: #41415a;
    font-weight: 500;
    padding: 3.5px 8px;
    cursor: default;
    background-color: white;
    border: 1px solid ${({ theme }) => theme.palette.borderColor};
    border-radius: 4px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 16.8px;
  }
`;
